import { render, staticRenderFns } from "./sceneMobile.vue?vue&type=template&id=7979459e&scoped=true&"
import script from "./sceneMobile.vue?vue&type=script&lang=js&"
export * from "./sceneMobile.vue?vue&type=script&lang=js&"
import style0 from "./sceneMobile.vue?vue&type=style&index=0&id=7979459e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7979459e",
  null
  
)

export default component.exports